<template>
  <div class="content_editor">
    <div v-if="controls" class="content_editor__controls">
      <button class="btn btn-sm btn-default"
              v-for="btn in btns"
              @click.prevent="addBlock(btn.type)">{{ $t(btn.title) }}</button>
    </div>
    <draggable v-if="controls" v-model="blocks" @end="onChange()" :options="{ handle:'.handle' }">
      <div v-for="(block, key) in blocks">
        <content-block-header v-if="block.type === 'header'"
                              :controls="controls"
                              :block="block"
                              :options="options"
                              :key="key"
                              @input="onChange()"
                              @remove="deleteBlock(key)"></content-block-header>

        <content-block-text v-else-if="block.type === 'text'"
                            :controls="controls"
                            :block="block"
                            :options="options"
                            :key="key"
                            @input="onChange()"
                            @remove="deleteBlock(key)"></content-block-text>

        <content-block-audio v-else-if="block.type === 'audio'"
                             :controls="controls"
                             :block="block"
                             :options="options"
                             :key="key"
                             @input="onChange()"
                             @remove="deleteBlock(key)"></content-block-audio>

        <content-block-video v-else-if="block.type === 'video'"
                             :controls="controls"
                             :block="block"
                             :options="options"
                             :key="key"
                             @input="onChange()"
                             @remove="deleteBlock(key)"></content-block-video>

        <content-block-youtube v-else-if="block.type === 'youtube'"
                             :controls="controls"
                             :block="block"
                             :options="options"
                             :key="key"
                             @input="onChange()"
                             @remove="deleteBlock(key)"></content-block-youtube>

        <content-block-files v-else-if="block.type === 'files'"
                             :controls="controls"
                             :block="block"
                             :options="options"
                             :key="key"
                             @input="onChange()"
                             @remove="deleteBlock(key)"></content-block-files>

        <content-block-gallery v-else-if="block.type === 'gallery'"
                               :controls="controls"
                               :block="block"
                               :options="options"
                               :key="key"
                               @input="onChange()"
                               @remove="deleteBlock(key)"></content-block-gallery>

        <content-block-quote v-else-if="block.type === 'quote'"
                             :controls="controls"
                             :options="options"
                             :block="block"
                             :key="key"
                             @input="onChange()"
                             @remove="deleteBlock(key)"></content-block-quote>

        <content-block-interruption v-else-if="block.type === 'interruption'"
                             :controls="controls"
                             :options="options"
                             :block="block"
                             :key="key"
                             @input="onChange()"
                             @remove="deleteBlock(key)"></content-block-interruption>

        <content-block-table v-else-if="block.type === 'table'"
                             :controls="controls"
                             :options="options"
                             :block="block"
                             :key="key"
                             @input="onChange()"
                             @remove="deleteBlock(key)"></content-block-table>

        <content-block-line v-else-if="block.type === 'line'"
                            :controls="controls"
                            :block="block"
                            :options="options"
                            :key="key"
                            @input="onChange()"
                            @remove="deleteBlock(key)"></content-block-line>
      </div>
    </draggable>
    <div v-else="controls">
      <div v-for="(block, key) in blocks">
        <content-block-header v-if="block.type === 'header'"
                              :controls="controls"
                              :block="block"
                              :options="options"
                              :key="key"
                              @input="onChange()"
                              @remove="deleteBlock(key)"></content-block-header>

        <content-block-text v-else-if="block.type === 'text'"
                            :controls="controls"
                            :options="options"
                            :block="block"
                            :key="key"
                            @input="onChange()"
                            @remove="deleteBlock(key)"></content-block-text>

        <content-block-audio v-else-if="block.type === 'audio'"
                             :controls="controls"
                             :block="block"
                             :options="options"
                             :key="key"
                             @input="onChange()"
                             @remove="deleteBlock(key)"></content-block-audio>

        <content-block-video v-else-if="block.type === 'video'"
                             :controls="controls"
                             :block="block"
                             :options="options"
                             :key="key"
                             @input="onChange()"
                             @remove="deleteBlock(key)"></content-block-video>

        <content-block-youtube v-else-if="block.type === 'youtube'"
                             :controls="controls"
                             :block="block"
                             :options="options"
                             :key="key"
                             @inpuyt="onChange()"
                             @remove="deleteBlock(key)"></content-block-youtube>

        <content-block-files v-else-if="block.type === 'files'"
                             :controls="controls"
                             :block="block"
                             :options="options"
                             :key="key"
                             @input="onChange()"
                             @remove="deleteBlock(key)"></content-block-files>

        <content-block-gallery v-else-if="block.type === 'gallery'"
                               :controls="controls"
                               :block="block"
                               :options="options"
                               :key="key"
                               @input="onChange()"
                               @remove="deleteBlock(key)"></content-block-gallery>

        <content-block-quote v-else-if="block.type === 'quote'"
                             :controls="controls"
                             :block="block"
                             :options="options"
                             :key="key"
                             @input="onChange()"
                             @remove="deleteBlock(key)"></content-block-quote>

        <content-block-interruption v-else-if="block.type === 'interruption'"
                             :controls="controls"
                             :block="block"
                             :options="options"
                             :key="key"
                             @input="onChange()"
                             @remove="deleteBlock(key)"></content-block-interruption>

        <content-block-table v-else-if="block.type === 'table'"
                             :controls="controls"
                             :block="block"
                             :options="options"
                             :key="key"
                             @input="onChange()"
                             @remove="deleteBlock(key)"></content-block-table>

        <content-block-line v-else-if="block.type === 'line'"
                             :controls="controls"
                             :block="block"
                             :options="options"
                             :key="key"
                             @input="onChange()"
                             @remove="deleteBlock(key)"></content-block-line>
      </div>
    </div>
    <div v-if="controls" class="content_editor__controls">
      <button class="btn btn-sm btn-default"
              v-for="btn in btns"
              @click.prevent="addBlock(btn.type)">{{ $t(btn.title) }}</button>
    </div>
  </div>
</template>

<script>
import ContentBlockHeader from './content-blocks/ContentBlockHeader'
import ContentBlockText from './content-blocks/ContentBlockText'
import ContentBlockAudio from './content-blocks/ContentBlockAudio'
import ContentBlockVideo from './content-blocks/ContentBlockVideo'
import ContentBlockYoutube from './content-blocks/ContentBlockYoutube'
import ContentBlockFiles from './content-blocks/ContentBlockFiles'
import ContentBlockGallery from './content-blocks/ContentBlockGallery'
import ContentBlockQuote from './content-blocks/ContentBlockQuote'
import ContentBlockInterruption from './content-blocks/ContentBlockInterruption'
import ContentBlockTable from './content-blocks/ContentBlockTable'
import ContentBlockLine from './content-blocks/ContentBlockLine'
import draggable from 'vuedraggable'

export default {
  name: "ContentEditor",
  components: {
    ContentBlockHeader,
    ContentBlockText,
    ContentBlockAudio,
    ContentBlockVideo,
    ContentBlockYoutube,
    ContentBlockFiles,
    ContentBlockGallery,
    ContentBlockQuote,
    ContentBlockInterruption,
    ContentBlockTable,
    ContentBlockLine,
    draggable
  },
  props: ['value', 'controls', 'options'],
  data () {
    return {
      blocks: [],
      btns: [
        {
          type: 'text',
          title: 'add_content_block_text'
        },
        {
          type: 'header',
          title: 'add_content_block_header'
        },
        {
          type: 'audio',
          title: 'add_content_block_audio'
        },
        {
          type: 'youtube',
          title: 'add_content_block_youtube'
        },
        {
          type: 'video',
          title: 'add_content_block_video'
        },
        {
          type: 'quote',
          title: 'add_content_block_quote'
        },
        {
          type: 'files',
          title: 'add_content_block_files'
        },
        {
          type: 'gallery',
          title: 'add_content_block_gallery'
        },
        {
          type: 'interruption',
          title: 'add_content_block_interruption'
        },
        {
          type: 'table',
          title: 'add_content_block_table'
        },
        {
          type: 'line',
          title: 'add_content_block_line'
        },
      ]
    }
  },
  watch: {
    value (val) {
      if (val) {
        this.blocks = JSON.parse(val);
      }
    }
  },
  mounted () {
    try {
      this.blocks = JSON.parse(this.value);
    } catch (e) {
      console.warn(e);
    }
  },
  methods: {
    addBlock (type) {

      let data = {
        text: ''
      };
      if (type === 'header') {
        data = {
          text: ''
        };
      }
      if (type === 'audio' || type === 'youtube') {
        data = {
          url: ''
        };
      }
      if (type === 'files' || type === 'gallery' || type === 'video') {
        data = {
          files: []
        };
      }

      if (type === 'quote') {
        data = {
          text: '',
          author: '',
          description: ''
        };
      }

      if (type === 'interruption') {
        data = {
          text: '',
          title: '',
          mark: '',
          info_bg_url: '',
          backdrop_image: ''
        };
      }

      if (type === 'table') {
        data = {
          rowsCount: 1,
          columnsCount: 1,
          data: [
            [
              ''
            ]
          ]
        };
      }

      this.blocks.push({
        type: type,
        data: data,
        edit: true
      });
    },
    deleteBlock (key) {
      this.blocks.splice(key, 1);
      this.onChange();
    },
    getBlocksJson () {
      return JSON.stringify(this.blocks.map(block => {
        delete block.edit;
        return block;
      }));
    },
    onChange () {
        this.$emit('input', this.getBlocksJson());
        this.$emit('change', this.getBlocksJson());
    },
  }
}
</script>
